export const GET_PUSH_SERVICE_INFO = 'GET_PUSH_SERVICE_INFO';
export const GET_PUSH_SERVICE_INFO_SUCCESS = 'GET_PUSH_SERVICE_INFO_SUCCESS';
export const GET_PUSH_SERVICE_INFO_FAILED = 'GET_PUSH_SERVICE_INFO_FAILED';

export const GET_UNREAD_NOTIFICATION = 'GET_UNREAD_NOTIFICATION';
export const GET_UNREAD_NOTIFICATION_SUCCESS = 'GET_UNREAD_NOTIFICATION_SUCCESS';
export const GET_UNREAD_NOTIFICATION_FAILED = 'GET_UNREAD_NOTIFICATION_FAILED';

export const READ_NOTIFICATION = 'READ_NOTIFICATION';
export const READ_NOTIFICATION_SUCCESS = 'READ_NOTIFICATION_SUCCESS';
export const READ_NOTIFICATION_FAILED = 'READ_NOTIFICATION_FAILED';
